import { render } from "./Info.vue?vue&type=template&id=24f1b0fe&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=24f1b0fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-24f1b0fe"

export default script